export const gtmTrackEvent = (event, data) => {
  window.dataLayer.push({
    event: 'udcwebsite_' + event,
    ...data
  })
}
